// @ts-nocheck


import React from 'react';
import InnerForm from '../components/InnerForm';
import { vehicleTariffEnum } from '../../../lib/enum';





export const VehicleTariffBrandForm = ({ vehicleTariffId }) => {
  return (
    <>
      <InnerForm
        vehicleTariffId={vehicleTariffId}
        type={vehicleTariffEnum.byBrand} />

    </>);

};

export default VehicleTariffBrandForm;
